<template>
    <div
        v-if="product?.category?.warrantyPolicy"
        class="product-warranty-info text-center"
    >
        <h1
            class="font-weight-regular"
        >
            DURABILITY GUARANTEED
        </h1>
        <p
            class="mt-0"
        >
            If your
            <span>{{ product.category.warrantyPolicy.name.toLocaleLowerCase() }}</span>
            breaks within its warranty period, we will replace it for free.
        </p>

        <img
            v-if="warrantyIconUrl"
            class="warranty-icon d-block invert-on-dark"
            :alt="`Warranty Length: ${warrantyLength}`"
            role="presentation"
            :src="warrantyIconUrl"
        />

        <v-row
            class="mt-8 px-8 text-left"
            justify-md="center"
        >
            <v-col
                md="3"
            >
                <h4
                    class="text-center text-md-start"
                >
                    Covered
                </h4>
                <ul
                    class="d-flex flex-column gap-2 ma-0 mt-2 pa-0 list-style-none"
                >
                    <li
                        v-for="(item, index) in product.category.warrantyPolicy.covered"
                        :key="index"
                    >
                        {{ item }}
                    </li>
                </ul>
            </v-col>
            <v-col
                md="3"
            >
                <h4
                    class="text-center text-md-start"
                >
                    Not Covered
                </h4>
                <ul
                    class="d-flex flex-column gap-2 ma-0 mt-2 pa-0 list-style-none"
                >
                    <li
                        v-for="(item, index) in product.category.warrantyPolicy.notCovered"
                        :key="index"
                    >
                        {{ item }}
                    </li>
                </ul>
            </v-col>
        </v-row>

        <div
            class="mt-8 text-size-fine"
        >
            <p>
                Photo documentation and proof of purchase are required.<br />
                Claims are eligible for account credit up to the amount spent on the item.<br />
                Claims submitted on a warranty replacement are eligible for up to 50% credit.<br />
                Claims submitted outside the warranty period may not qualify for any credit.
            </p>
        </div>
    </div>
    <div v-else>
        <!-- Intentionally Empty -->
    </div>
</template>

<script lang="ts" setup>
    import {
        useCdnResource
    } from 'x1-base/composables';
    import type { Product } from '~/types';

    const props = defineProps({
        product: {
            type: Object as PropType<Product>,
            default: () => {}
        }
    });

    const useCdnResourceObj = useCdnResource();
    const warrantyLength = ref(props.product.warrantyLength);

    const warrantyIconUrl = computed<string | null>(() => {
        if (warrantyLength.value && warrantyLength.value !== '0') {
            return useCdnResourceObj.getResourceCdnUrl(
                `/static/common/images/svg/warranty/${warrantyLength.value}.svg`
            );
        }

        return null;
    });
</script>

<style lang="scss">
.product-warranty-info {
    .warranty-icon {
        height: 64px;
        width: auto;
        margin: 32px auto;
    }
}
</style>
